import React from 'react';
import css from './PublicPricingPage.module.css';

const SHOPIFY_STATIC_PLANS = [
  {
    title: 'Free',
    price: 'Free to install',
    secondaryPoints: ['14 days free'],
    sub: '500 Free contacts',
    description: ['14 days free'],
    trial: '',
  },
  {
    title: 'Shopify Intro',
    price: '$99/mo',
    sub: '$0.25 per contact captured',
    description: [
      'X-Ray Pixel',
      'Advanced CRM Integrations',
      'Suppression lists',
    ],
    trial: 'A free trial is available for 14 days',
  },
  {
    title: 'Shopify Starter',
    price: ' $199/mo',
    sub: '$0.23 per contact captured',
    description: [
      'X-Ray Pixel',
      'Advanced CRM Integrations',
      'Suppression lists',
    ],
    trial: 'A free trial is available for 14 days',
  },
  {
    title: 'Shopify Pro',
    price: '$399/mo',
    sub: '$0.18 per contact captured',
    description: [
      'X-Ray Pixel',
      'Advanced CRM Integrations',
      'Suppression lists',
    ],
    trial: 'A free trial is available for 14 days',
  },
  {
    title: 'Shopify Advanced',
    price: '$799/mo',
    sub: '$0.13 per contact captured',
    description: [
      'X-Ray Pixel',
      'Advanced CRM Integrations',
      'Suppression lists',
    ],
    trial: 'A free trial is available for 14 days',
  },
];

export const PublicPricingPage = () => {
  return (
    <div className={css.page}>
      <div className={css.content}>
        <div className={css.info}>
          <span className={css.name}>Pricing</span>
        </div>

        <div className={css.plans}>
          {SHOPIFY_STATIC_PLANS.map(v => (
            <div className={css.card}>
              <div className={css.title}>{v.title}</div>
              <div className={css.price}>{v.price}</div>

              <hr />
              <div className={css.sub}>{v.sub}</div>
              <div className={css.description}>
                {v?.description?.map(j => (
                  <span>{j}</span>
                ))}
              </div>

              {v.trial && <span className={css.trial}>{v.trial}</span>}
            </div>
          ))}
        </div>

        <div className={css.footer}>
          All charges are billed in USD. Recurring and usage-based charges are
          billed every 30 days.
        </div>
      </div>
    </div>
  );
};
